import axios from 'axios';

function getCookie(cname) {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${cvalue};${expires};`;
}

class Translator {
  constructor() {
    this.config = {};
    this.currentLanguage = 'undef';
    axios.get('./language.json')
      .then((resp) => {
        this.config = resp.data;
        const lang = getCookie('lang');
        this.setLanguage(lang.toString());
        if (this.currentLanguage === 'undef') {
          this.currentLanguage = 'pl';
          setCookie('lang', 'pl', 30);
        }
      })
      .catch((err) => console.error(err));
  }

  L(key) {
    if (key === '') {
      return '';
    }
    return this.config[this.currentLanguage][key] !== undefined ? this.config[this.currentLanguage][key] : `Translation ${this.currentLanguage} - ${key} does not exist`;
  }

  setLanguage(lg) {
    if (typeof lg === 'string') {
      if (this.config[lg] !== undefined) {
        this.currentLanguage = lg;
        setCookie('lang', lg, 30);
      }
    }
  }
}

const translator = new Translator();

export default translator;
